import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'

class EditWidgets extends Component {
  constructor(props) {
    super(props)

    this.props.setIframeFormState(null)
    this.onChange = this.onChange.bind(this)
  }

  onChange() {
    document.getElementById('edit-iframe-loader').classList.add('hidden')
    document.getElementById('edit-form-iframe').classList.remove('hidden')
  }

  render() {
    if (this.props.iframeFormStatus === 'submitting') {
      document.getElementById('edit-iframe-loader').classList.remove('hidden')
      document.getElementById('edit-form-iframe').classList.add('hidden')
    } else if (this.props.iframeFormStatus === 'cancel') {
      this.props.cancel()
      this.props.setIframeFormState(null)
    } else if (typeof this.props.iframeFormStatus !== 'string' && this.props.iframeFormStatus !== null) {
      this.props.reloadIframe(this.props.PreviwUrl)
      this.props.setIframeFormState(null)
      this.props.cancel()
    }

    return (
      <Col xs={12} className="iframe-forms-content">
        <Row>
          <Col xs={12}>
            <Col xs={8}>
              <h1 className="title">{window.I18n.t('multi_widgets.widgets.edit_title')}</h1>
            </Col>
            <Col xs={4}>
              <span onClick={ () => this.props.cancel() } className="pull-right x-button">
                <i className="fa fa-times fa-fw"></i>
              </span>
            </Col>
          </Col>
          <Col xs={12} className="inner-content">
            <div className="form-row" id="modal-setting">
              <div id="edit-iframe-loader" className="loader">{window.I18n.t('multi_widgets.widgets.loading')}</div>
              <iframe width="100%"
                      height="500px"
                      src={ this.props.URL }
                      frameBorder="0"
                      id="edit-form-iframe"
                      onLoad={ () => this.onChange() }
                      className='hidden'
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen></iframe>
            </div>
          </Col>
        </Row>
      </Col>
    )
  }
}

EditWidgets.propTypes = {
  URL: PropTypes.any,
  PreviwUrl: PropTypes.any,
  cancel: PropTypes.func,
  reloadIframe: PropTypes.func,
  iframeFormStatus: PropTypes.any,
  setIframeFormState: PropTypes.func,
}

export default EditWidgets
